import React from "react";
import classes from "./HomePage2.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetIndex } from "../slices/activeTileSlice";
import { resetEnteredWords } from "../slices/enteredWordSlice";
import { resetTargetWord } from "../slices/targetWordSlice";
import { resetTargetWord3 } from "../slices/targetWord3Slice";
import { resetWord3Result } from "../slices/word3Result";
import { resetWordResult } from "../slices/wordResult";
import { resetTiles } from "../slices/tileWordSlice";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import Lottie from "lottie-react";
import animationData from "../staticAnimations/thinkAnimation.json";
import Button from "../components/newComponents/Button";
import BottomNavbar from "../components/newComponents/BottomNavbar";

const HomePage2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateHandler = (path) => {
    dispatch(resetIndex());
    dispatch(resetTiles());
    dispatch(resetEnteredWords());
    dispatch(resetTargetWord());
    dispatch(resetTargetWord3());
    dispatch(resetWord3Result());
    dispatch(resetWordResult());
    navigate(path);
  };
  return (
    <>
      <Layout>
        <Card>
          <CardHeader title="Welcome to Word Game..." />
          <Lottie animationData={animationData} loop={true} autoplay={true} />

          <Button text="Play" onPress={() => navigateHandler("/levels")} />
        </Card>
        <BottomNavbar active={1} />
      </Layout>
    </>
  );
};

export default HomePage2;
